/* =========================================================================
   ClueVine — mode registration
   Importing this module registers every mode with the engine. Add a new mode
   by importing it and calling registerMode — nothing else in the app changes.
   ========================================================================= */

import { registerMode } from '../engine/registry';
import { bloomMode } from './bloom';
import { bouquetMode } from './bouquet';
import { branchesMode } from './branches';
import { brambleMode } from './bramble';
import { cipherMode } from './cipher';
import { forgeMode } from './forge';
import { latticeMode } from './lattice';
import { petalMode } from './petal';
import { tangleMode } from './tangle';
import { thornMode } from './thorn';
import { trellisMode } from './trellis';

registerMode(cipherMode);
registerMode(forgeMode);
registerMode(tangleMode);
registerMode(trellisMode);
registerMode(branchesMode);
registerMode(brambleMode);
registerMode(bloomMode);
registerMode(petalMode);
registerMode(bouquetMode);
registerMode(thornMode);
registerMode(latticeMode);

export {
  cipherMode,
  forgeMode,
  tangleMode,
  trellisMode,
  branchesMode,
  brambleMode,
  bloomMode,
  petalMode,
  bouquetMode,
  thornMode,
  latticeMode,
};
